angular.module("Main").factory("BookingCalculationService", [function () {
    var calendarData = [];
    var calendarTimes = [];
    var calendarEmptyDays = [];
    var origData = null;

    return {
        calculateCalendar: calculateCalendar,
        getCalendar: getCalendar,
        getCalendarTimeline: getCalendarTimeline,
        getEmptyDays: getEmptyDays,
        getAppointmentsForDate: getAppointmentsForDate,
        chooseAppointment: chooseAppointment,
        getCalendar2: getCalendar2
    };

    function calculateCalendar(data, endDate) {
        calendarData = [];
        calendarTimes = [];
        calendarEmptyDays = [];
        origData = data;

        var rawData = [];
        var minHour = -1, maxHour = -1;
        _.forEach(data, function (dataDay) {
            var rawDayData = [];
            var appsForTime = [];
            if (!_.isEmpty(dataDay) && new Date(dataDay[0].Start) < endDate) {
                var groupedDay = _.groupBy(dataDay, function (d) {
                    return new Date(d.Start).getHours();
                });
                _.forEach(groupedDay, function (value, key) {
                    key = _.toInteger(key);
                    var apps = _.orderBy(_.uniqBy(value, "Start"), ["Start"]);
                    rawDayData.push({time: key, apps: apps, count: apps.length});

                    if (minHour < 0 || minHour > key)
                        minHour = key;
                    if (maxHour < 0 || maxHour < key)
                        maxHour = key;

                    var index = _.findIndex(calendarTimes, {time: key});
                    if (index < 0) {
                        calendarTimes.push({time: key, count: apps.length, apps: apps});
                        let foundCalendarTime = _.find(calendarTimes, {time: key});
                        _.concat(foundCalendarTime.apps, apps);
                    }

                    else if (calendarTimes[index].count < apps.length)
                        calendarTimes[index].count = apps.length;
                });

                rawData.push(rawDayData);
                calendarEmptyDays.push(false);
            } else {
                rawData.push([]);
                calendarEmptyDays.push(true);
            }
        });

        // for (var h = minHour + 1; h < maxHour; ++h) {
        //     if (_.findIndex(calendarTimes, {time: h}) < 0)
        //         calendarTimes.push({time: h, count: 1});
        // }
        calendarTimes = _.orderBy(calendarTimes, ["time"]);
        return ({calendarTimes: calendarTimes, rawData: rawData})


    }

    function getCalendarTimeline() {
        return calendarTimes.calendarTimes;
    }

    function getCalendar2(allHours, week) {
        let weekData = [];
        _.forEach(week, function (weekday) {
            if(weekday.length === 0) {
                weekData.push(weekday)
            } else {
                let weekDay = [];
                _.forEach(allHours, function (hour) {
                    let apps = hour.apps;
                    let uniqueStarts = [];
                    apps.forEach(item => {
                        uniqueStarts.push(new Date(item.Start).toTimeString())
                    });
                    uniqueStarts.sort();
                    uniqueStarts = removeDuplicates(uniqueStarts);
                    function removeDuplicates(arr) {
                        let unique = arr.reduce(function (acc, curr) {
                            if (!acc.includes(curr))
                                acc.push(curr);
                            return acc;
                        }, []);
                        return unique;
                    }
                    let hourThisDay = _.find(weekday, {time: hour.time});
                    if (_.isUndefined(hourThisDay) || hourThisDay.apps.length === 0) {
                       // let weekDayHour = [];
                        _.forEach(uniqueStarts, function (uniqueStart) {
                            weekDay.push({appointment: {Start: uniqueStart, visible: false, count: 1}});
                        });
                      //  weekDay.push(weekDayHour)
                    } else {
                       // let weekDayHour = [];
                       // weekDayHour.time = hour.time;
                        _.forEach(hourThisDay.apps, function (appo) {
                            for(var i = 0; i < hourThisDay.apps.length; i++) {
                                let st = new Date(appo.Start).toTimeString();
                                if(uniqueStarts.length === 0) {
                                    appo.visible = true;
                                    weekDay.push({appointment:appo});
                                }
                                if (uniqueStarts[i] < st) {
                                    weekDay.push({appointment: {Start: uniqueStarts[i], visible: false, count: 1}});
                                    uniqueStarts = uniqueStarts.filter(v => v !== uniqueStarts[i]);
                                }
                                if (uniqueStarts[i] === st || uniqueStarts[i] > st) {
                                    appo.visible = true;
                                    weekDay.push({appointment:appo});
                                    uniqueStarts = uniqueStarts.filter(v => v !== uniqueStarts[i]);
                                }
                               break;
                            }

                        });
                       // weekDay.push(weekDayHour)
                    }
                });
                //_.flattenDeep(weekDay);
                weekData.push(weekDay);
            }
        })
        return weekData
    }


    function getCalendar(calendarTimes, rawData, Nachlauf) {
        _.forEach(rawData, function (rdd) {
            var caldata = [];
            _.forEach(calendarTimes, function (caltime) {
                var foundTimeAll = [];
                var foundTimeAllTimeStrings = [];
                foundTimeAll.apps = [];
                var foundTime = _.flattenDeep(_.map(_.flattenDeep(_.filter(_.flattenDeep(rawData), {time: caltime.time})), 'apps'));
                _.forEach(foundTime, function (found) {
                    let foundStart = new Date(found.Start);
                    let foundStartTimeString = foundStart.toTimeString();
                    if (foundTimeAllTimeStrings.indexOf(foundStartTimeString) === -1) {
                        foundTimeAllTimeStrings.push(foundStartTimeString)
                        foundTimeAll.apps.push(found)
                    }
                });
                if (!_.isNil(_.find(rdd, {time: caltime.time}))) {
                    let foundinDay = _.find(rdd, {time: caltime.time});

                    foundinDay.apps.forEach((timeInDay, index) => {
                        let timeInDayStart = (new Date(timeInDay.Start));
                        let countBefore = 0;
                        let indexesToRemove = [];
                        for (var i = 0; i < foundTimeAll.apps.length; ++i) {
                            if (index <= foundinDay.apps.length - 1) {
                                let foundTimeAllDayStart = (new Date(foundTimeAll.apps[i].Start));
                                if (timeInDayStart.toTimeString() === foundTimeAllDayStart.toTimeString()) {
                                    if (countBefore > 0) {
                                        caldata.push({hour: caltime.time, count: countBefore, border: true})
                                    }
                                    caldata.push({appointment: timeInDay, border: true});
                                    indexesToRemove.push(i);
                                    break;
                                    if(index === foundinDay.apps.length - 1){
                                        break;
                                    }
                                }
                                else if(timeInDayStart.toTimeString() > foundTimeAllDayStart.toTimeString())  {
                                    countBefore++;
                                    indexesToRemove.push(i);
                                }

                            } else {
                                if (i < foundTimeAll.apps.length) {
                                    caldata.push({hour: caltime.time, count: countBefore + (foundTimeAll.apps.length - i), border: true});
                                }
                            }
                        }
                            foundTimeAll.apps.splice(0, indexesToRemove.length);
                        if(index===foundinDay.apps.length-1 && foundTimeAll.apps.length>0) {
                            caldata.push({hour: caltime.time, count: foundTimeAll.apps.length, border: true})
                        }

                    })
                }
                else {
                    caldata.push({hour: caltime.time, count: foundTimeAll.apps.length, border: true});
                }

            });

            calendarData.push(caldata);
        });
        return calendarData;
    }

    function getEmptyDays() {
        return calendarEmptyDays;
    }

    function getAppointmentsForDate(date) {
        if (!_.isEmpty(origData)) {
            for (var i = 0; i < 7; ++i) {
                if (!_.isEmpty(origData[i])) {
                    var result = _.filter(origData[i], {Start: date});
                    if (!_.isEmpty(result))
                        return result;
                }
            }
        }

        return [];
    }

    function chooseAppointment(appointments) {
        if (!_.isArray(appointments) || _.isEmpty(appointments))
            return null;

        var r = _.random(_.size(appointments) - 1);
        return appointments[r];
    }
}]);